import { render, staticRenderFns } from "./tipsComponent.vue?vue&type=template&id=f7b7353e&scoped=true"
import script from "./tipsComponent.vue?vue&type=script&lang=js"
export * from "./tipsComponent.vue?vue&type=script&lang=js"
import style0 from "./tipsComponent.vue?vue&type=style&index=0&id=f7b7353e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b7353e",
  null
  
)

export default component.exports